var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgReplace = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M9.969 15.37h4.96a.43.43 0 0 0 .317-.128.43.43 0 0 0 .128-.317.43.43 0 0 0-.128-.317.43.43 0 0 0-.316-.128H9.969l1.268-1.268a.4.4 0 0 0 .128-.311.454.454 0 0 0-.445-.45.41.41 0 0 0-.317.127l-2.036 2.036a.4.4 0 0 0-.094.144.5.5 0 0 0 0 .334q.028.078.094.144l2.036 2.036a.41.41 0 0 0 .317.128.454.454 0 0 0 .445-.45.4.4 0 0 0-.128-.312zm4.061-5.85H9.07a.43.43 0 0 1-.318-.128.43.43 0 0 1-.128-.317.43.43 0 0 1 .128-.317.43.43 0 0 1 .317-.128h4.961l-1.268-1.268a.4.4 0 0 1-.128-.311.454.454 0 0 1 .445-.45.41.41 0 0 1 .317.127l2.035 2.036a.4.4 0 0 1 .095.144.5.5 0 0 1 0 .334.4.4 0 0 1-.095.144l-2.035 2.036a.41.41 0 0 1-.317.128.453.453 0 0 1-.445-.45.4.4 0 0 1 .128-.312z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReplace);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/replace.22175e67.svg";